import { createStyles, makeStyles } from '@material-ui/core';
import { theme } from '@nask/theme';

export const useStyles = makeStyles(({ spacing }) =>
  createStyles({
    header: {
      padding: spacing(1, 0, 1, 5),
    },
    tab: {
      fontSize: theme.typography.paragraphFontSize,
      textTransform: 'none',
    },
    tabSelected: {
      color: theme.colors.focused,
      fontWeight: 'bold',
    },
    indicator: {
      height: 0,
      backgroundColor: 'transparent',
    },
  })
);
